import React, { useEffect, useState, useContext } from "react";
import { Select, MenuItem } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import shortid from "shortid";

import useHttp from "../../../../../hooks/useHttp";
import { COUNTRY_STATE_N_CITY_LIST_URL } from "../../../../../utils/api-ends";
import { ManageLoadPostContext } from "../..";

const Destination = () => {
  const google = window.google;
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const { sendRequests } = useHttp();
  const [mapInputRef, setMapInputRef] = useState(undefined);

  const [loadPostState, loadPostContextDispatch] = useContext(
    ManageLoadPostContext
  );
  const loadPostInfo = loadPostState.loadPostInfo;
  const errorMessages = loadPostState.loadPostInfoErrors;

  const onChange = (e) => {
    const { name, value } = e.target;
    loadPostContextDispatch({
      type: "ON_CHANGE_LOAD_POST_INFO",
      payload: { name, value },
    });
  };

  const onChangeCheckbox = (e) => {
    const { name, checked } = e.target;
    loadPostContextDispatch({
      type: "ON_CHANGE_LOAD_POST_INFO",
      payload: { name, value: checked },
    });
  };

  const getCountry = () => {
    const response = (data) => {
      setCountries(data);
    };
    sendRequests(
      {
        url: COUNTRY_STATE_N_CITY_LIST_URL,
        method: "GET",
        params: {
          data_type: "countries",
        },
      },
      response
    );
  }

  const getState = (country) => {
    const response = (data) => {
      setStates(data);
    };
    sendRequests(
      {
        url: COUNTRY_STATE_N_CITY_LIST_URL,
        method: "GET",
        params: {
          data_type: "states",
          country_name: country,
        },
      },
      response
    );
  }

  // Fetch list of country
  useEffect(() => {
    getCountry();
  }, [sendRequests]);

  // // Fetch list of state
  useEffect(() => {
    if (loadPostInfo.destination_country) {
      getState(loadPostInfo.destination_country);
    }
  }, [loadPostInfo.destination_country, sendRequests]);

  // Show or hide error messages on mouse enter or leave
  const showErrorMessage = (e) =>
    e.currentTarget.setAttribute("show-tittle", "true");
  const hideErrorMessage = (e) =>
    e.currentTarget.setAttribute("show-tittle", "false");

  useEffect(() => {
    if (mapInputRef) {
      var options = {
        componentRestrictions: {
          country: ["us", "gh", "ng"],
        },
      };

      var place_autoSearch = new google.maps.places.Autocomplete(
        mapInputRef,
        options
      );

      google.maps.event.addListener(place_autoSearch, "place_changed", () => {
        var search_box_input_data = {
          target: {
            name: "destination_address",
            value: mapInputRef.value,
          },
        };

        onChange(search_box_input_data);

        let get_place = place_autoSearch.getPlace();
        let get_lat_lng = get_place.geometry.location;

        if (get_lat_lng) {
          loadPostContextDispatch({
            type: "ON_CHANGE_LOAD_POST_INFO",
            payload: {
              name: "destination_latitude",
              value: get_lat_lng.lat(),
            },
          });
          loadPostContextDispatch({
            type: "ON_CHANGE_LOAD_POST_INFO",
            payload: {
              name: "destination_longitude",
              value: get_lat_lng.lng(),
            },
          });
        }

        // Get country and state from the address
        let country = "";
        let state = "";
        let postal_code = "";
        let city = "";

        get_place.address_components.forEach(component => {
          if (component.types.includes("country")) {
            country = component.long_name; // e.g., "United States"
            if (country === "United States") {
              country = "USA";
            }
            getState(country);
          }

          if (component.types.includes("administrative_area_level_1")) {
            state = component.long_name;
          }

          if (component.types.includes("postal_code")) {
            postal_code = component.long_name;
          }

          if (component.types.includes("locality")) {
            city = component.long_name;
          }
        });

        loadPostContextDispatch({
          type: "ON_CHANGE_LOAD_POST_INFO",
          payload: {
            name: "destination_country",
            value: country,
          },
        });

        loadPostContextDispatch({
          type: "ON_CHANGE_LOAD_POST_INFO",
          payload: {
            name: "destination_state",
            value: state,
          },
        });

        loadPostContextDispatch({
          type: "ON_CHANGE_LOAD_POST_INFO",
          payload: {
            name: "destination_postal_code",
            value: postal_code,
          },
        });

        loadPostContextDispatch({
          type: "ON_CHANGE_LOAD_POST_INFO",
          payload: {
            name: "destination_city",
            value: city,
          },
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapInputRef]);

  return (
    <div className="information-field border-0">
      <div className="input-box-area" single-labe="true">
        <label> Contact Name </label>
        <input
          type="text"
          placeholder="Contact Name"
          name="destination_contact_name"
          value={loadPostInfo.destination_contact_name}
          onChange={onChange}
        />

        {errorMessages.destination_contact_name?.length > 0 && (
          <div
            className="error"
            show-tittle="false"
            onMouseEnter={showErrorMessage}
            onMouseLeave={hideErrorMessage}>
            <i className="fa-solid fa-circle-exclamation"></i>
            {errorMessages.destination_contact_name?.map((error, index) => (
              <p key={shortid.generate()}>{error}</p>
            ))}
          </div>
        )}
      </div>

      <div className="input-box-area" single-labe="true">
        <label> Contact Phone Number </label>

        <div className="phone-number-input-area">
          <input
            type="text"
            defaultValue="+1"
            disabled="true"
            className="phone-number-input-code"
          />
          <input
            type="text"
            placeholder="e.g. 6505552671"
            defaultValue="+1"
            name="destination_contact_phone_number"
            value={loadPostInfo.destination_contact_phone_number}
            onChange={onChange}
          />
        </div>

        {errorMessages.destination_contact_phone_number?.length > 0 && (
          <div
            className="error"
            show-tittle="false"
            onMouseEnter={showErrorMessage}
            onMouseLeave={hideErrorMessage}>
            <i className="fa-solid fa-circle-exclamation"></i>
            {errorMessages.destination_contact_phone_number?.map(
              (error, index) => (
                <p key={shortid.generate()}>{error}</p>
              )
            )}
          </div>
        )}
      </div>

      <div className="input-box-area" single-labe="true">
        <label> Full Address (Select Suggested Address Recommended) </label>
        <input
          type="text"
          placeholder="Address..."
          name="destination_address"
          value={loadPostInfo.destination_address}
          onChange={onChange}
          ref={setMapInputRef}
        />

        {errorMessages.destination_address?.length > 0 && (
          <div
            className="error"
            show-tittle="false"
            onMouseEnter={showErrorMessage}
            onMouseLeave={hideErrorMessage}>
            <i className="fa-solid fa-circle-exclamation"></i>
            {errorMessages.destination_address?.map((error, index) => (
              <p key={shortid.generate()}>{error}</p>
            ))}
          </div>
        )}
      </div>

      <div className="input-box-area" single-labe="true">
        <label> Country </label>
        <Select
          name="destination_country"
          value={loadPostInfo.destination_country}
          onChange={onChange}
          fullWidth
          className="mui-select-field-without-label"
          inputProps={{ "aria-label": "Without label" }}>
          {countries?.map((state) => (
            <MenuItem key={state} value={state}>
              {state}
            </MenuItem>
          ))}
        </Select>
        {errorMessages.destination_country?.length > 0 && (
          <div
            className="error"
            show-tittle="false"
            onMouseEnter={showErrorMessage}
            onMouseLeave={hideErrorMessage}>
            <i className="fa-solid fa-circle-exclamation"></i>
            {errorMessages.destination_country?.map((error, index) => (
              <p key={shortid.generate()}>{error}</p>
            ))}
          </div>
        )}
      </div>

      <div className="input-box-area" single-labe="true">
        <label> State/Region </label>
        <Select
          name="destination_state"
          value={loadPostInfo.destination_state}
          onChange={onChange}
          fullWidth
          className="mui-select-field-without-label"
          inputProps={{ "aria-label": "Without label" }}>
          {states?.map((state) => (
            <MenuItem key={state} value={state}>
              {state}
            </MenuItem>
          ))}
        </Select>

        {errorMessages.destination_state?.length > 0 && (
          <div
            className="error"
            show-tittle="false"
            onMouseEnter={showErrorMessage}
            onMouseLeave={hideErrorMessage}>
            <i className="fa-solid fa-circle-exclamation"></i>
            {errorMessages.destination_state?.map((error, index) => (
              <p key={shortid.generate()}>{error}</p>
            ))}
          </div>
        )}
      </div>

      <div className="input-box-area" single-labe="true">
        <label> City </label>
        <input
          type="text"
          placeholder="City"
          name="destination_city"
          value={loadPostInfo.destination_city}
          onChange={onChange}
        />

        {errorMessages.destination_city?.length > 0 && (
          <div
            className="error"
            show-tittle="false"
            onMouseEnter={showErrorMessage}
            onMouseLeave={hideErrorMessage}>
            <i className="fa-solid fa-circle-exclamation"></i>
            {errorMessages.destination_city?.map((error, index) => (
              <p key={shortid.generate()}>{error}</p>
            ))}
          </div>
        )}
      </div>

      <div className="input-box-area" single-labe="true">
        <label> Postal Code </label>
        <input
          type="text"
          placeholder="Postal Code"
          name="destination_postal_code"
          value={loadPostInfo.destination_postal_code}
          onChange={onChange}
        />

        {errorMessages.destination_postal_code?.length > 0 && (
          <div
            className="error"
            show-tittle="false"
            onMouseEnter={showErrorMessage}
            onMouseLeave={hideErrorMessage}>
            <i className="fa-solid fa-circle-exclamation"></i>
            {errorMessages.destination_postal_code?.map((error, index) => (
              <p key={shortid.generate()}>{error}</p>
            ))}
          </div>
        )}
      </div>

      <div className="check-box">
        <FormControlLabel
          control={
            <Checkbox
              name="is_destination_port"
              checked={loadPostInfo.is_destination_port}
              onChange={onChangeCheckbox}
            />
          }
          label="Is Destination Port"
        />
      </div>
    </div>
  );
};

export default Destination
